import { FC } from "react";
import { PaymentStatusFilterBox } from "ui";
import useBillingStore from "../../stores/billing-store/billing-store";
import { paymentFiltersObj } from "../../stores/billing-store/utils";
import { PaymentStatusFilterType } from "../../types/appointment";
import { track } from "../../utils/tracking";

const PaymentStatusFilters: FC<{}> = (): JSX.Element => {
  const {
    filterMeta,
    paymentGroupFilter,
    setPaymentGroupFilter,
    isReceiptEntitiesLoading,
  } = useBillingStore();

  return (
    <div className="flex items-center w-full mt-16 space-x-16 px-16">
      {Object.entries(paymentFiltersObj).map(([key, value]) => (
        <PaymentStatusFilterBox
          key={key}
          label={value.label}
          onClick={() => {
            setPaymentGroupFilter(key as PaymentStatusFilterType);
            track("BILLING_FILTER_SELECT", {
              type: "PAYMENT_STATUS",
              optionsSelected: key,
            });
          }}
          isSelected={paymentGroupFilter === key}
          isLoading={isReceiptEntitiesLoading}
          count={filterMeta && filterMeta[key as PaymentStatusFilterType].count}
          amount={
            filterMeta && filterMeta[key as PaymentStatusFilterType].amount
          }
        />
      ))}
    </div>
  );
};

export default PaymentStatusFilters;
